import styles from "./FiltersFacultyMobile.module.scss";
import { Badge, Drawer } from "antd";
import {
  DEFAULT_SEARCH_PARAMS,
  ParamsFilterKey,
} from "Config/filterSearchParams";
import { AutoCompleteFilters } from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { getSuggestSearchAuthors } from "Explore/Services/Author";
import useFilterAndPagination from "Hooks/useFilterAndPagination";
import { useEffect, useMemo, useState } from "react";
import FilterFaculty from "../FiltersFaculty";

const FiltersFacultyMobile = () => {
  const { filter, updateSearchParams } = useFilterAndPagination();
  const [open, setOpen] = useState(false);
  const [tempFilters, setTempFilters] = useState(filter);

  const totalFilterApplied = useMemo(
    () =>
      Object.keys(filter).reduce((total, key) => {
        let _total = total;
        if (!!filter[key]) {
          if (Array.isArray(filter[key])) {
            _total += filter[key].length;
          } else if (filter[key] !== DEFAULT_SEARCH_PARAMS[key]) {
            _total += 1;
          }
        }
        return _total;
      }, 0),
    [filter]
  );

  useEffect(() => {
    setTempFilters(filter);
  }, [filter]);

  const onClose = () => {
    setOpen(false);
    setTempFilters(filter);
  };
  const showDrawer = () => {
    setOpen(true);
  };

  const onApplyFilters = () => {
    updateSearchParams(tempFilters);
    setOpen(false);
  };
  const onClearFilters = () => {
    setTempFilters(DEFAULT_SEARCH_PARAMS);
  };
  const onChangeFilters = (newFilter) => {
    setTempFilters({
      ...tempFilters,
      ...newFilter,
    });
  };

  return (
    <div className={styles["filters-faculty-mobile"]}>
      {/* <AutoCompleteFilters
        placeholder={"Search by faculty name..."}
        functionSearch={getSuggestSearchAuthors}
        filters={filter}
        setFilters={updateSearchParams}
        entity={ParamsFilterKey.QUERY}
        style={{ width: "100%", height: "36px" }}
      /> */}
      <Badge count={totalFilterApplied}>
        <div className={styles["filter-trigger"]} onClick={showDrawer}>
          {IconPack.menuIcon}
        </div>
      </Badge>

      <Drawer
        title="Faculty Filters"
        placement={"bottom"}
        closable={true}
        onClose={onClose}
        open={open}
        key={"bottom"}
        height={"90vh"}
        zIndex={1001}
        footer={
          <div className={styles["filters-footer"]}>
            <button
              className={styles["clear-button"]}
              onClick={() => onClearFilters()}
            >
              Clear
            </button>
            <button
              className={styles["apply-button"]}
              onClick={() => onApplyFilters()}
            >
              Apply
            </button>
          </div>
        }
      >
        <FilterFaculty filter={tempFilters} updateFilter={onChangeFilters} />
      </Drawer>
    </div>
  );
};

export default FiltersFacultyMobile;
